import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, Paper, Typography, useTheme } from '@mui/material'
import NoSessionImage from 'assets/svg/session-not-found.svg'
import splashArt from 'assets/svg/splash_no-session.svg'
import LKQBackground from 'assets/svg/lkq-background.svg'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { useGetRedirectURI } from '../hooks/useGetRedirectURI'
import { useHistory } from 'react-router-dom'
import { useGetAzureRedirectURI } from '../hooks/useGetAzureRedirectURI'

const NoSession: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { data: redirectURI } = useGetRedirectURI()
  const { data: azureRedirectURI } = useGetAzureRedirectURI()
  const history = useHistory()

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${LKQBackground})`,
        backgroundSize: 'auto, 100%',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: { lg: '50vw', xl: '40vw' },
          mx: 'auto'
        }}
      >
        <Paper sx={{ overflow: 'hidden', width: '100%' }}>
          <Grid container>
            <Grid item xs={6}>
              <Box
                sx={{
                  backgroundColor: 'rgba(255, 136, 129,0.3)',
                  pt: 10,
                  pb: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  height: '100%',
                  position: 'relative'
                }}
              >
                <Box
                  sx={{
                    display: 'block',
                    width: '3.5em',
                    height: '3.5em',
                    backgroundColor: 'error.light',
                    mask: `url(${NoSessionImage}) no-repeat center`,
                    position: 'absolute',
                    top: theme.spacing(3),
                    left: theme.spacing(3)
                  }}
                />
                <Box component='img' alt='splash-art' src={splashArt} sx={{ flex: '1 0 130%' }} />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', p: 3, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <Typography variant='h4'>{t('Auth.NoSessionText')}</Typography>
                  {!redirectURI && (
                    <Button size='large' variant='contained' onClick={() => history.push('/')} sx={{ mt: 2 }}>
                      {t('Auth.BtnBackToLogin')}
                    </Button>
                  )}
                  {redirectURI && (
                    <>
                      <Typography variant='body1' sx={{ my: 3, textAlign: 'center' }}>
                        {t('Auth.WelcomeSubtitleSupport')}
                      </Typography>
                      <Button
                        startIcon={<LockOpenIcon />}
                        size='large'
                        variant='contained'
                        href={redirectURI}
                        data-testid='support-login-button'
                        sx={{ marginBottom: 2, width: '220px' }}
                      >
                        {t('Auth.BtnLoginOkta')}
                      </Button>
                      {azureRedirectURI && (
                        <Button
                          startIcon={<LockOpenIcon />}
                          size='large'
                          variant='contained'
                          href={azureRedirectURI}
                          data-testid='support-azure-login-button'
                          sx={{ width: '220px' }}
                        >
                          {t('Auth.BtnLoginAzure')}
                        </Button>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  )
}

export default NoSession
